<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <div class="my-5 display-1">Login</div>
        <v-form v-on:submit.prevent="login">
          <v-text-field tabindex="1" v-model="email" label="email" required @input="error=false" autocomplete="email" ref="email"></v-text-field>
          <v-text-field tabindex="2" v-model="password" label="lozinka" required @input="error=false" autocomplete="current-password"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'" @click:append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"></v-text-field>
          <v-btn class="primary my-5" large block tabindex="3" type="submit" :disabled="!valid" :loading="loading">login</v-btn>
          <p><router-link to="/register">registracija</router-link></p>
          <p><router-link to="/resetPassword">zaboravljena lozinka?</router-link></p>
        </v-form>
        <v-alert v-model="error" type="error" dismissible>
          Pogrešna kombinacija
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import auth from '@/services/authService'
import cordovaService from '@/services/cordovaService'
import { log } from '@/services/logService.js'

export default {
  data () {
    return {
      email: '',
      password: '',
      showPassword: false,
      loading: false,
      valid: true,
      error: false
    }
  },
  created () {
    this.$nextTick(() => this.$refs.email.focus())
  },
  methods: {
    login () {
      let vm = this
      vm.loading = true
      auth.login(vm.email.toLowerCase().trim(), vm.password, function () {
        log('login success')
        cordovaService.onLogin()
        vm.$router.push(vm.$router.currentRoute.query.redirect || '/')
      }, function (err) {
        // show login error
        log('login failed', err)
        vm.error = true
        vm.loading = false
      })
    }
  }
}

</script>

<style scoped>

</style>
